module.exports = __webpack_public_path__ + "img/sysxcx.3db6eea9.png";